module.exports = __webpack_public_path__ + "static/media/ID_Front.35e92313.png";